// extracted by mini-css-extract-plugin
export default {"list-card":"CampaignDetail_list-card__0cwpp","main-card":"CampaignDetail_main-card__qYsW3"};